import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 flex-wrap gap-10" }
const _hoisted_4 = { class: "d-flex align-items-center flex-wrap gap-10" }
const _hoisted_5 = {
  class: "position-relative",
  style: {"min-width":"220px","max-width":"300px"}
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_12 = {
  key: 0,
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_13 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_14 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_15 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_16 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = {
  key: 0,
  class: "shadow-none lh-1 fw-medium text-black-emphasis"
}
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_20 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_21 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_22 = {
  key: 0,
  class: "d-flex align-items-center gap-8"
}
const _hoisted_23 = ["value", "disabled", "onChange"]
const _hoisted_24 = { value: "ACTIVE" }
const _hoisted_25 = { value: "INACTIVE" }
const _hoisted_26 = {
  key: 0,
  class: "spinner-border spinner-border-sm text-secondary",
  role: "status"
}
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_29 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_30 = {
  key: 0,
  class: "dropdown"
}
const _hoisted_31 = { class: "dropdown-menu" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "" }
const _hoisted_36 = {
  key: 0,
  class: "pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
}
const _hoisted_37 = {
  key: 0,
  class: "mb-0 text-paragraph"
}
const _hoisted_38 = { class: "fw-bold" }
const _hoisted_39 = { class: "fw-bold" }
const _hoisted_40 = {
  key: 1,
  class: "mb-0 text-paragraph"
}
const _hoisted_41 = { class: "fw-bold" }
const _hoisted_42 = { class: "fw-bold" }
const _hoisted_43 = { class: "mt-15 mt-md-0" }
const _hoisted_44 = { class: "pagination mb-0" }
const _hoisted_45 = {
  key: 0,
  class: "page-item"
}
const _hoisted_46 = {
  key: 0,
  class: "page-link active",
  href: "#"
}
const _hoisted_47 = ["onClick"]
const _hoisted_48 = {
  key: 1,
  class: "page-item"
}
const _hoisted_49 = {
  class: "modal fade",
  id: "filterLeadModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_50 = { class: "modal-dialog modal-sm modal-dialog-centered" }
const _hoisted_51 = { class: "modal-content" }
const _hoisted_52 = { class: "modal-header" }
const _hoisted_53 = { class: "modal-title fs-5" }
const _hoisted_54 = { class: "modal-body" }
const _hoisted_55 = { style: {} }
const _hoisted_56 = {
  key: 0,
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_59 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_60 = { class: "modal-footer" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}
const _hoisted_63 = { style: {"color":"#FFF"} }
const _hoisted_64 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_65 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_66 = { class: "modal-content" }
const _hoisted_67 = { class: "modal-header" }
const _hoisted_68 = { class: "modal-title fs-5" }
const _hoisted_69 = { class: "modal-body" }
const _hoisted_70 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_71 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_72 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_73 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_74 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_75 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_76 = { class: "row" }
const _hoisted_77 = { class: "col-md-6" }
const _hoisted_78 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_79 = ["placeholder"]
const _hoisted_80 = { class: "invalid-feedback" }
const _hoisted_81 = { class: "col-md-6" }
const _hoisted_82 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_83 = {
  value: "",
  disabled: ""
}
const _hoisted_84 = { class: "invalid-feedback" }
const _hoisted_85 = { class: "row" }
const _hoisted_86 = { class: "col-md-6" }
const _hoisted_87 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_88 = {
  value: "",
  disabled: ""
}
const _hoisted_89 = ["value"]
const _hoisted_90 = { class: "invalid-feedback" }
const _hoisted_91 = { class: "col-md-6" }
const _hoisted_92 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_93 = {
  value: "",
  disabled: ""
}
const _hoisted_94 = ["value"]
const _hoisted_95 = { class: "invalid-feedback" }
const _hoisted_96 = { class: "row" }
const _hoisted_97 = { class: "col-md-6" }
const _hoisted_98 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_99 = ["placeholder"]
const _hoisted_100 = { class: "invalid-feedback" }
const _hoisted_101 = { class: "col-md-6" }
const _hoisted_102 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_103 = { class: "modal-footer" }
const _hoisted_104 = {
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}
const _hoisted_105 = {
  key: 0,
  class: "spinner-grow spinner-grow-sm",
  role: "status",
  "aria-hidden": "true",
  style: {"color":"#FFF"}
}

import {ref, onMounted,reactive,inject, computed } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useRouter } from 'vue-router';
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { Organization,Balance } from "@/utils/Model";
import { useTableFilter } from "../../utils/UseTablefilter";

import {current_permissions} from '../../utils/permission';
import {validate_phone_number,showToast,checkSessionValidate} from "@/utils/function";


export default /*@__PURE__*/_defineComponent({
  __name: 'BalanceContent',
  setup(__props) {

const backApi=inject('back');

const btnLoad = ref(true);
const { t } = useI18n();

const loader = ref(false);

let token: string|null = localStorage.getItem('login_token');
let codeOrganization: string|null = localStorage.getItem('organization_code');
let codeUser: string|null = localStorage.getItem('code');
let role: string|null = localStorage.getItem('role');

// Rôles autorisés à gérer les balances (création/édition/statut)
const allowedStatusRoles = ['SUPERADMIN', 'BUSINESS', 'SUPPORT'];
const canManageBalanceStatus = computed(() => allowedStatusRoles.includes((role || '').toUpperCase()));

const updatingCode = ref('');

const selectedValidation = ref('');

const balance =ref(new Array<Balance>());
const countries = ref([] as any[]);
const operators = ref([] as any[]);

let edit = 0;
let itemCode = '';
let selectedOrganization = '';

const {
  searchQuery,
  paginatedData: paginatedBalances,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  balance,
  [
    (b: any) => b.code,
    (b: any) => b.country?.name,
    (b: any) => b.operator?.mnoName,
    (b: any) => b.balanceType,
    (b: any) => b.status,
    (b: any) => b.balance,
  ],
  15
);



  let data = [];
 
  const errors = ref('');  
  const errorId = ref('');  
  const success = ref('');
  const errorsBis = {'name':'','country':'','operator':'','balanceLimit':'','balanceType':''};
  const pageLoad = ref(false);

  const formValues = reactive({
    name: "",
    balanceType: "",
    balanceLimit: null,
    status: "ACTIVE",
    operator: "",
    country: "",
    // Champs utilisés par le formulaire de transfert (sendMoney / showTransfert)
    amount: 0,
    phone: "",
    first_name: "",
    last_name: "",
  });


  const schema = yup.object({
      name: yup.string().required('Le nom est requis'),
      balanceType: yup.string().oneOf(['BOTH', 'PAYOUT', 'PAYIN'], 'Type de balance invalide').required('Le type de balance est requis'),
      balanceLimit: yup.number().nullable().transform((v, orig) => (orig === '' ? null : v)),
      status: yup.string().required('Le statut est requis'),
      operator: yup.string().required("L'opérateur est requis"),
      country: yup.string().required('Le pays est requis'),
  });



function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}
const initField = () =>{
  formValues.name = '';
  formValues.balanceType = '';
  formValues.balanceLimit = null;
  formValues.status = 'ACTIVE';
  formValues.operator = '';
  formValues.country = '';
  errors.value = '';
  errorId.value = '';
  success.value = '';
  edit=0;
}

// Liste des pays pour le select "country" du formulaire
const getCountries = () => {
  axios.get(backApi+'/secure/countries/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    countries.value = response.data.data ?? response.data;
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

// Liste des opérateurs pour le select "operator" du formulaire
// L'API pagine les résultats (ex: 10 items/page, 14 au total sur 2 pages),
// on boucle donc sur toutes les pages via pagination.nextPage jusqu'à
// récupérer l'intégralité des opérateurs avant de les affecter à operators.value.
const getOperators = async (page = 1, accumulated: any[] = []) => {
  try {
    const response = await axios.get(backApi + '/secure/operators/', {
      params: { page },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const pageData = response.data.data ?? response.data;
    const merged = accumulated.concat(pageData);
    const pagination = response.data.pagination;

    if (pagination && pagination.nextPage) {
      // il reste des pages à charger, on continue la récupération
      await getOperators(pagination.nextPage, merged);
    } else {
      operators.value = merged;
    }
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

// NB: pour un SUPERADMIN on garde le filtre ?status=ACTIVE (toutes organisations),
// pour les autres rôles on filtre en plus par organisation. Auparavant "param"
// était calculé mais jamais utilisé dans l'URL (bug), et la réponse était
// assignée en bloc (response.data) au lieu du tableau qu'elle contient
// (response.data.data), ce qui cassait la pagination/recherche côté front.
const getBalance = (arg=1) =>{
    let param = '';
    param = (role=='SUPERADMIN')?'?status=ACTIVE':`?status=ACTIVE&organization=${codeOrganization}`
    axios.get(backApi+'/secure/provider/balance/'+param,{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        balance.value = response.data.data ?? response.data;
        data  = balance.value;  
        // total.value=parseInt(response.data.pagination.total);
        // page.value=parseInt(response.data.pagination.page);
        // pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        // currentPage.value=parseInt(response.data.pagination.currentPage);
        // numPages.value=parseInt(response.data.pagination.numPages);

    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const showBalance = (code) =>{
    axios.get(backApi+'/secure/balance/'+code+'/show',{
      headers: {

            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        formValues.name = response.data.name;
        formValues.balanceType = response.data.balanceType ?? '';
        formValues.balanceLimit = response.data.balanceLimit ?? null;
        formValues.status = response.data.status ?? 'ACTIVE';
        formValues.operator = response.data.operator?.code ?? response.data.operator ?? '';
        formValues.country = response.data.country?.code ?? response.data.country ?? '';

        itemCode = response.data.code;

        edit=1;
        console.log(response.data);
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                console.log(error.response);
              }   
              
          }
  });
}

const showTransfert = (code) =>{
    // +arg
     axios.get(backApi+'/secure/contactbook/'+code+'/show',{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        // balance.value = response.data;  //.data.balance 
        formValues.phone=  response.data.contact;  
        formValues.first_name=  response.data.first_name; 
        formValues.last_name=  response.data.last_name; 
        itemCode = response.data.code;
              
           
        console.log(response.data);
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                console.log(error.response);
              }   
              
          }
  });
}


/**
 * Change le statut d'un balance via /secure/provider/balance/{code}/status
 * Autorisé uniquement pour SUPERADMIN / BUSINESS / SUPPORT (cf. canManageBalanceStatus).
 */
const changeBalanceStatus = (balanceItem, newStatus) => {
  if (!canManageBalanceStatus.value) {
    return;
  }

  const oldStatus = balanceItem.status;
  if (oldStatus === newStatus) {
    return;
  }

  updatingCode.value = balanceItem.code;

  axios.put(`${backApi}/secure/provider/balance/${balanceItem.code}/status`, {
      status: newStatus
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      balanceItem.status = newStatus;
      showToast("Statut mis à jour avec succès", "green");
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          errorId.value = error.response.data?.errorId ?? '';
          errors.value = error.response.data?.message ?? "une erreur inattendue est apparue";
          showToast(errors.value, "red");
        }
      }
      // on remet l'ancien statut en cas d'échec
      balanceItem.status = oldStatus;
    })
    .finally(() => {
      updatingCode.value = '';
    });
}

const onStatusChange = (event, balanceItem) => {
  changeBalanceStatus(balanceItem, event.target.value);
}

const showScreen = (code)=>{ 
  itemCode=code;
  
}

const cancel = () =>{
  itemCode="";
  errorId.value="";
  errors.value="";
}

const save =()=>{
  if (edit==0){
    storeBalance()
  }else{
    updateBalance()
    
  }
  
}


const sendMoney =()=>{
btnLoad.value=false;
if(parseFloat(formValues.amount)>0  && selectedValidation.value!==''){
try {  
  schema.validateSync(formValues);

  axios.post(`${backApi}/secure/transactions/init`,{
    clientId:formValues.first_name+" "+formValues.last_name,    
    operator:selectedValidation.value,
    amount:parseFloat(formValues.amount),
    mobile:formValues.phone,
    operationType:parseInt(process.env.VUE_APP_PAYOUT_OPTTYPE),
    successUrl: "https://billing.api/success",
    errorUrl: "https://billing.api/error"
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        btnLoad.value=true;
        if(response.status === 201){      
          //router.go();
           
          showToast("Transfert réussi","green");
          formValues.amount=0;
          formValues.phone='';
          selectedValidation.value='N';          
        }      
        
    }).catch((error) => {
      if( error.response){
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        console.error(error);        
         errors.value="une erreur inattendue est apparue"
      
}
}else{
  if(parseFloat(formValues.amount)==0){
      showToast("Veuillez saisir un montant correct","red");
  }else{
      showToast("Veuillez sélectionner un opérateur","red");
  }
  
}
btnLoad.value=true;
}

const storeBalance = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);

    axios.post(`${backApi}/secure/provider/balance/new`, {
      name: formValues.name,
      balanceType: formValues.balanceType,
      balanceLimit: formValues.balanceLimit === '' ? null : formValues.balanceLimit,
      status: formValues.status,
      operator: formValues.operator,
      country: formValues.country,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200 || response.status === 201) {
        console.log(response);
        showToast("Enregistrement effectué avec succès", "green");
        router.go();
      }

    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')

        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }

      }
    });
  } catch (error) {
    btnLoad.value = true;
    errors.value = "une erreur inattendue est apparue"

  }

}

const updateBalance = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);

    axios.put(`${backApi}/secure/balance/${itemCode}/edit`, {
      name: formValues.name,
      balanceType: formValues.balanceType,
      balanceLimit: formValues.balanceLimit === '' ? null : formValues.balanceLimit,
      status: formValues.status,
      operator: formValues.operator,
      country: formValues.country,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        router.go();
      }

    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')

        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }

      }
    });
  } catch (error) {
    btnLoad.value = true;
    errors.value = "une erreur inattendue est apparue"

  }

}

const deleteBalance =()=>{
  btnLoad.value=false;
try {   
  // alert(itemCode);
  const headers = {
  'Authorization':  `Bearer ${token}`
  }
const data = {
  code: itemCode
}
  axios.delete(`${backApi}/secure/balance/delete`, {headers, data})
  .then(response => {
    if(response.status === 200){ 
      btnLoad.value=true;
          console.log(response);          
          router.go();  
        }   
})
.catch(error => {
  if( error.response){
      
      if(error.response.status === 401){
        router.push('/')
        
      }else{
        errorId.value=error.response.data.errorId;
        errors.value=error.response.data.message;
      } 
      
  }
});

} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         
              
}

}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}

const exportExcel = () =>{
  
  import("../../utils/Export2Excel").then((excel)=>{
    // const data = transactions.value;
    const Header =["CODE RECHARGEMENT","DESCRIPTION","MONTANT","DATE","STATUT"];
    const Fields = ["code","description","amount","createdAt","status"];
    // console.log(data);
    const dataForExcel= formatJSon(Fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"rechargement",      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

function formatJSon(FilterData,JsonData){
  return JsonData.map((v)=>FilterData.map(j=>{
      return v[j];
    }));
}


 onMounted(async () => { 
  checkSessionValidate(1);
   getBalance();
   getCountries();
   getOperators();

   setTimeout(function () {
    pageLoad.value=true; 
         },1000)
 
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[17] || (_cache[17] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchQuery) ? (searchQuery).value = $event : null)),
                  type: "text",
                  class: "form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16",
                  placeholder: _ctx.$t('balances.search')
                }, null, 8, _hoisted_6), [
                  [_vModelText, _unref(searchQuery)]
                ])
              ])
            ]),
            (canManageBalanceStatus.value && _unref(current_permissions)('list_providers'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("button", {
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [...(_cache[18] || (_cache[18] = [
                    _createTextVNode(" Ajouter un balance ", -1),
                    _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1)
                  ]))])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("table", _hoisted_10, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('balances.code')), 1),
                    (_unref(current_permissions)('list_providers'))
                      ? (_openBlock(), _createElementBlock("th", _hoisted_12, _toDisplayString(_ctx.$t('balances.country')), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t('balances.name')), 1),
                    _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t('balances.type')), 1),
                    _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t('balances.status')), 1),
                    _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t('balances.balance')), 1),
                    _cache[19] || (_cache[19] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedBalances), (balanceItem) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: balanceItem.code
                    }, [
                      _createElementVNode("td", _hoisted_17, _toDisplayString(balanceItem.code), 1),
                      (_unref(current_permissions)('list_providers'))
                        ? (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(balanceItem.country?.name), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_19, _toDisplayString(balanceItem.operator?.mnoName), 1),
                      _createElementVNode("td", _hoisted_20, _toDisplayString(balanceItem.balanceType), 1),
                      _createElementVNode("td", _hoisted_21, [
                        (canManageBalanceStatus.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _createElementVNode("select", {
                                class: "form-select form-select-sm shadow-none",
                                style: {"min-width":"130px"},
                                value: balanceItem.status,
                                disabled: updatingCode.value === balanceItem.code,
                                onChange: ($event: any) => (onStatusChange($event, balanceItem))
                              }, [
                                _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.$t('balances.active') || 'ACTIVE'), 1),
                                _createElementVNode("option", _hoisted_25, _toDisplayString(_ctx.$t('balances.inactive') || 'INACTIVE'), 1)
                              ], 40, _hoisted_23),
                              (updatingCode.value === balanceItem.code)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(balanceItem.status), 1))
                      ]),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(balanceItem.balance?.toLocaleString()), 1),
                      _createElementVNode("td", _hoisted_29, [
                        (canManageBalanceStatus.value && _unref(current_permissions)('list_providers'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _cache[22] || (_cache[22] = _createElementVNode("button", {
                                class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                                type: "button",
                                "data-bs-toggle": "dropdown",
                                "aria-expanded": "false"
                              }, [
                                _createElementVNode("i", { class: "flaticon-dots" })
                              ], -1)),
                              _createElementVNode("ul", _hoisted_31, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    style: {"color":"red"},
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#filterLeadModal",
                                    onClick: ($event: any) => (showScreen(balanceItem.code))
                                  }, [
                                    _cache[20] || (_cache[20] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('balances.delete')), 1)
                                  ], 8, _hoisted_32)
                                ]),
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#companyModal",
                                    onClick: ($event: any) => (showBalance(balanceItem.code))
                                  }, [
                                    _cache[21] || (_cache[21] = _createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)),
                                    _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('balances.edit')), 1)
                                  ], 8, _hoisted_34)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ]),
            (_unref(filteredTotal)>0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  (_unref(filteredTotal)>10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_37, [
                        _createTextVNode(_toDisplayString(_ctx.$t('balances.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(page)*10), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('balances.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('balances.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(filteredTotal)<=10)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_40, [
                        _createTextVNode(_toDisplayString(_ctx.$t('balances.showing')) + " ", 1),
                        _createElementVNode("span", _hoisted_41, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('balances.outOf')) + " ", 1),
                        _createElementVNode("span", _hoisted_42, _toDisplayString(_unref(filteredTotal)), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('balances.results')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("nav", _hoisted_43, [
                    _createElementVNode("ul", _hoisted_44, [
                      ((_unref(page)-1)>0)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_45, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToPage)(_unref(page)-1))),
                              "aria-label": "Previous"
                            }, [...(_cache[23] || (_cache[23] = [
                              _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(numPages), (numPage) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: numPage,
                          class: "page-item"
                        }, [
                          (numPage==_unref(page))
                            ? (_openBlock(), _createElementBlock("a", _hoisted_46, _toDisplayString(numPage), 1))
                            : (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "page-link",
                                onClick: ($event: any) => (_unref(goToPage)(numPage))
                              }, _toDisplayString(numPage), 9, _hoisted_47))
                        ]))
                      }), 128)),
                      ((_unref(page)+1)<=_unref(numPages))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_48, [
                            _createElementVNode("a", {
                              class: "page-link",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToPage)(_unref(page)+1))),
                              "aria-label": "Next"
                            }, [...(_cache[24] || (_cache[24] = [
                              _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                            ]))])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_49, [
      _createElementVNode("div", _hoisted_50, [
        _createElementVNode("div", _hoisted_51, [
          _createElementVNode("div", _hoisted_52, [
            _createElementVNode("h1", _hoisted_53, _toDisplayString(_ctx.$t('balances.alert')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel()))
            })
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              (errors.value=='')
                ? (_openBlock(), _createElementBlock("h6", _hoisted_56, _toDisplayString(_ctx.$t('balances.confirmDelete')), 1))
                : _createCommentVNode("", true)
            ]),
            (errors.value!=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                  _createElementVNode("h6", _hoisted_58, "code: " + _toDisplayString(errorId.value), 1),
                  _createElementVNode("h6", _hoisted_59, _toDisplayString(errors.value), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("button", {
              type: "button",
              class: "btn default-outline-btn bg-transparent",
              style: {"background-color":"#FFF"},
              "data-bs-dismiss": "modal",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (cancel()))
            }, _toDisplayString(_ctx.$t('balances.no')), 1),
            _createElementVNode("button", {
              disabled: !btnLoad.value,
              type: "button",
              class: "btn",
              style: {"background-color":"#EB9355"},
              onClick: _cache[5] || (_cache[5] = ($event: any) => (deleteBalance()))
            }, [
              (!btnLoad.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_62))
                : _createCommentVNode("", true),
              _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('balances.yes')), 1)
            ], 8, _hoisted_61)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_64, [
      _createElementVNode("div", _hoisted_65, [
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_67, [
              _createElementVNode("h1", _hoisted_68, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('balances.addBalance') : _ctx.$t('balances.editBalance')), 1),
              _cache[25] || (_cache[25] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_69, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                    _createElementVNode("h6", _hoisted_71, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_72, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                    _createElementVNode("h6", _hoisted_74, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_75, [
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("div", _hoisted_77, [
                    _createElementVNode("label", _hoisted_78, _toDisplayString(_ctx.$t('balances.balanceName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        placeholder: _ctx.$t('balances.balanceNamePlaceholder'),
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formValues.name) = $event)),
                        id: "name",
                        onBlur: _cache[7] || (_cache[7] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_79), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_80, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t('balances.balanceType') || 'Type de balance'), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-select fs-md-15 text-black shadow-none", { 'is-invalid': errorsBis['balanceType'] }]),
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formValues.balanceType) = $event)),
                        id: "balanceType",
                        onChange: _cache[9] || (_cache[9] = ($event: any) => (validate('balanceType')))
                      }, [
                        _createElementVNode("option", _hoisted_83, _toDisplayString(_ctx.$t('balances.selectBalanceType') || 'Sélectionner un type'), 1),
                        _cache[26] || (_cache[26] = _createElementVNode("option", { value: "BOTH" }, "BOTH", -1)),
                        _cache[27] || (_cache[27] = _createElementVNode("option", { value: "PAYOUT" }, "PAYOUT", -1)),
                        _cache[28] || (_cache[28] = _createElementVNode("option", { value: "PAYIN" }, "PAYIN", -1))
                      ], 34), [
                        [_vModelSelect, formValues.balanceType]
                      ]),
                      _createElementVNode("span", _hoisted_84, _toDisplayString(errorsBis['balanceType']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_85, [
                  _createElementVNode("div", _hoisted_86, [
                    _createElementVNode("label", _hoisted_87, _toDisplayString(_ctx.$t('balances.country')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-select fs-md-15 text-black shadow-none", { 'is-invalid': errorsBis['country'] }]),
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formValues.country) = $event)),
                        id: "country",
                        onChange: _cache[11] || (_cache[11] = ($event: any) => (validate('country')))
                      }, [
                        _createElementVNode("option", _hoisted_88, _toDisplayString(_ctx.$t('balances.selectCountry') || 'Sélectionner un pays'), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (c) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: c.code,
                            value: c.code
                          }, _toDisplayString(c.name), 9, _hoisted_89))
                        }), 128))
                      ], 34), [
                        [_vModelSelect, formValues.country]
                      ]),
                      _createElementVNode("span", _hoisted_90, _toDisplayString(errorsBis['country']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_91, [
                    _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t('balances.operator') || 'Opérateur'), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("select", {
                        class: _normalizeClass(["form-select fs-md-15 text-black shadow-none", { 'is-invalid': errorsBis['operator'] }]),
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formValues.operator) = $event)),
                        id: "operator",
                        onChange: _cache[13] || (_cache[13] = ($event: any) => (validate('operator')))
                      }, [
                        _createElementVNode("option", _hoisted_93, _toDisplayString(_ctx.$t('balances.selectOperator') || 'Sélectionner un opérateur'), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(operators.value, (o) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: o.code,
                            value: o.code
                          }, _toDisplayString(o.name), 9, _hoisted_94))
                        }), 128))
                      ], 34), [
                        [_vModelSelect, formValues.operator]
                      ]),
                      _createElementVNode("span", _hoisted_95, _toDisplayString(errorsBis['operator']), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("div", _hoisted_97, [
                    _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t('balances.balanceLimit') || 'Limite du balance'), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['balanceLimit'] }]),
                        placeholder: _ctx.$t('balances.balanceLimitPlaceholder') || 'Laisser vide si aucune limite',
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formValues.balanceLimit) = $event)),
                        id: "balanceLimit",
                        onBlur: _cache[15] || (_cache[15] = ($event: any) => (validate('balanceLimit')))
                      }, null, 42, _hoisted_99), [
                        [_vModelText, formValues.balanceLimit]
                      ]),
                      _createElementVNode("span", _hoisted_100, _toDisplayString(errorsBis['balanceLimit']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_101, [
                    _createElementVNode("label", _hoisted_102, _toDisplayString(_ctx.$t('balances.status')), 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select fs-md-15 text-black shadow-none",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formValues.status) = $event)),
                      id: "status"
                    }, [...(_cache[29] || (_cache[29] = [
                      _createElementVNode("option", { value: "ACTIVE" }, "ACTIVE", -1),
                      _createElementVNode("option", { value: "INACTIVE" }, "INACTIVE", -1)
                    ]))], 512), [
                      [_vModelSelect, formValues.status]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_103, [
              _createElementVNode("button", _hoisted_104, [
                (!btnLoad.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_105))
                  : _createCommentVNode("", true),
                _cache[30] || (_cache[30] = _createElementVNode("i", {
                  class: "flaticon-plus position-relative ms-5 fs-12",
                  style: {"color":"#FFF"}
                }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_unref(edit) == 0 ? _ctx.$t('balances.save') : _ctx.$t('balances.edit')), 1)
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[31] || (_cache[31] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})